export default "__VITE_ASSET__So87DWAv__"